<script>
const icons = {
  'calendar-check': () => import('./svg/calendar-check.vue'),
}

const requireComponents = require.context('./svg/', false, /[\w]+.vue$/)

requireComponents.keys().forEach((fileName) => {
  const iconName = fileName.replace(/^\.\/(.+)\.vue/, '$1')
  const componentConfig = requireComponents(fileName)
  icons[iconName] = componentConfig.default || componentConfig
})

export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    size: {
      type: [String, Number],
      default: 24,
    },
    color: {
      type: String,
      default: 'currentColor',
    },
  },
  computed: {
    iconComponent() {
      return icons[this.name]
    },
    // True when `color` is already a literal CSS value (var(--x), hex,
    // rgb()/rgba()/hsl()/hsla(), currentColor) and must NOT be wrapped as a
    // theme name.
    //
    // ⚠️ `rgb(`/`hsl(` entraram em 2026-08-02 porque a ausência deles não
    // degradava: fazia o ícone SUMIR. Uma cor funcional caía no ramo de nome
    // de tema e virava `var(--rgba(0, 0, 0, 0.26))` — custom property
    // inválida, `fill: none`, `stroke: none`, nada desenhado. Falha silenciosa
    // e difícil de atribuir: o chamador passou uma cor CSS válida, e o que
    // aparece na tela é um buraco. Ver A-57.
    isCssColorValue() {
      return (
        this.color.indexOf('var(') === 0 ||
        this.color.includes('#') ||
        this.color === 'currentColor' ||
        /^(rgba?|hsla?)\(/.test(this.color)
      )
    },
    colorFormatted() {
      return this.isCssColorValue ? this.color : `var(--${this.color})`
    },
    // Vuetify 2.0.11's v-icon `color` prop only understands theme color
    // names or #/rgb/hsl literals — it does NOT resolve `var(--x)` strings
    // (it builds an invalid `var(--x)--text` class, so the icon falls back
    // to the default gray). Route var(...) colors through an inline style
    // instead, and keep the `color` prop for everything else (unchanged).
    isVarColor() {
      return this.color.indexOf('var(') === 0
    },
    vIconColor() {
      return this.isVarColor ? null : this.color
    },
    vIconStyle() {
      return this.isVarColor ? { color: this.color } : null
    },
  },
}
</script>

<template>
  <!-- class="inline-block fill-current"
  style="height: 1em; width: 1em;" -->
  <!-- role="img" -->
  <div class="icon-svg full-center" :class="'icon-' + name">
    <component
      :is="iconComponent"
      v-if="iconComponent"
      :size="size"
      :color="colorFormatted"
      v-bind="$attrs"
      v-on="$listeners"
    />
    <v-icon
      v-else
      :color="vIconColor"
      :style="vIconStyle"
      :size="size"
      v-bind="$attrs"
      v-on="$listeners"
      v-text="name"
    ></v-icon>
  </div>
</template>
